import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { T } from '../../i18n/index';
import type { MithrilVNode } from '../../mithril';
import { IkePageName } from '../../page/page';
import { Services } from '../../services';

function stopPropagation(e: Event) {
	e.stopPropagation();
}

export const CSS = {
	container: 'c-MapEditModeButton',
};

export const TopologicalEditorButton = {
	view(tagId: string, center: string): MithrilVNode {
		return ImageButton.view(MaterialIcon.EDIT_LOCATION, {
			title: T.LINK_MAP_MODE,
			href: IkePageName.topologicalEditor,
			hrefParams: {
				jobId: tagId,
				location: center,
			},
			disabled: false,
			onclick: stopPropagation,
		});
	},
};

export const TopologicalEditorCollectionButton = {
	view(tagId: string, collectionUUID: string): MithrilVNode {
		return ImageButton.view(MaterialIcon.EDIT_LOCATION, {
			className: CSS.container,
			title: T.LINK_MAP_MODE,
			disabled: false,
			onclick: (e) => {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				Services.Window.confirmPageChange(
					e,
					Services.Route.getRouteURL(IkePageName.topologicalEditor, {
						jobId: tagId,
						collectionUUID,
					})
				);
			},
		});
	},
};
